import constant from '../../store/constant'

export default {
  name: 'shop-list',
  data () {
    return {
    }
  },
  created () {
    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
      // this.$store.dispatch('SHOP_SEARCH')
      this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})
    } else {
      this.$store.dispatch('CANNOT_USE')
    }
  },
  computed: {
    currentShopId () {
      var shopId = this.$store.getters.currentShopId
      if (shopId !== null) {
        shopId = shopId.toString()
      }
      return shopId
    },
    shops () {
      return this.$store.getters.shops
    },
    currentShopName () {
      var shopName = this.$t('shop_list.shop_all')
      if (this.$store.getters.currentShopName !== null) {
        shopName = this.$store.getters.currentShopName
      }
      return shopName;
    },
    loading () {
      return this.$store.getters.apiLoading
    },
  },
  methods: {
    setCurrentShopId (shopId) {
      window.sessionStorage.clear()
      this.$store.dispatch('CHANGE_SHOP', {data: {shop_id: shopId}})
      .then(
        (res) => {
          if (this.$route.path === '/shops') {
            // this.$router.go(-1)
            this.$router.push({ path: '/' }) // TOPへ
          }
        },
        () => {}
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-list.js